import React from "react";
import { Bar, Line, defaults } from 'react-chartjs-2';
import StatisticsGraph from "./StatisticsGraph";


export default class PreOrderTimeChart extends StatisticsGraph {

    init() {
        super.init()
    }

    apiUrl = '/api/preorder-time-data';
    formId = 'preorder-time-chart-form';
    varPrefix = 'preOrderTimeChart';
    formEnabled = true;
    state = Object.assign({}, this.state, {
        diagram_data: null,
        x_axis: null,
        diagram_type: 'bar'
    })
    params = Object.assign({}, this.params, {x_axis: 'week'})

    get_x_labels() {
        return this.state.diagram_data.map( (agg_result, index) => {
            const point = index + 1
            const pointStr = `${point} `
            switch (this.state.x_axis) {
                case 'hour':
                    return pointStr + 'Stunde'  + (point === 1 ? '' : 'n')
                case 'day':
                    return pointStr + 'Tag' + (point === 1 ? '' : 'e' )
                case 'week':
                    return pointStr + 'Woche' + (point === 1 ? '' : 'n')
                case 'month':
                    return pointStr + 'Monat' + (point === 1 ? '' : 'e' )
            }
        })
    }

    get_data_values(data) {
        return data.map(agg_result => agg_result.doc_count)
    }

    get_chartjs_options() {
        if(!this.state.diagram_data) {
            return {}
        }
        return {
            scales: {
                yAxes: [
                    {
                        scaleLabel: {
                            display: true,
                            labelString: $('#y_axis option:selected').text()
                        },
                        ticks: {
                            beginAtZero: true,
                            callback: (value, index, values) => {
                                return value
                            }
                        }
                    }
                ],
                xAxes: [
                    {
                        scaleLabel: {
                            display: true,
                            labelString: $('#x_axis option:selected').text()
                        }
                    }
                ]
            },
            tooltips: {
                callbacks: {
                    label: (tooltipItem, data) => this.renderTooltipLabel(tooltipItem, data)
                }
            }
        };
    }

    renderTooltipLabel(tooltipItem, data) {
        return `Bestellungen: ${tooltipItem.yLabel}`
    }

    get_chartjs_data() {
        if(!this.state.diagram_data) {
            return {}
        }
        const result = {
            "labels": this.get_x_labels(),
            "datasets": [this.create_dataset(
                this.get_data_values(this.state.diagram_data),
                '',
                'rgba(224, 6, 117, 0.2)',
                'rgba(224, 6, 117, 1)')
            ]
        };

        return result
    }

    postData(sendParams) {
        $.post(this.apiUrl, sendParams)
            .then(data => {
                if (data.status)
                    return;

                this.setState({
                    diagram_data: data.data.diagram_data.pre_order_timespan_seconds,
                    x_axis: data.data.x_axis,
                    initialized: true,
                });
            });
    }

    create_dataset(data, label, backgroundColor, borderColor) {
        return{
            data,
            label,
            "fill": false,
            "borderWidth": 1,
            backgroundColor,
            borderColor
        }
    }

    render() {
        if (!this.state.initialized) {
            return (
                <div className="search-table-loading col-md-12">
                    ... wird geladen ...
                </div>
            );
        }
        return (
            <div>
                <div className='row'>
                    <div className='col-md-3'>
                        <label htmlFor='diagram_type'>Diagrammart</label>
                        <select id='diagram_type' className='form-control' value={this.state.diagram_type} onChange={(e) => this.setState({diagram_type: e.target.value})}>
                            <option value='bar'>Balkendiagramm</option>
                            <option value='line'>Liniendiagramm</option>
                        </select>
                    </div>
                    <div className='col-md-9'>
                    </div>
                </div>
                <div className='row mt-3'>
                    <div className="col-md-12">
                        <div className={'statistics-box'}>
                            {this.state.diagram_type == 'bar' ? <Bar
                                data={this.get_chartjs_data()}
                                height={500}
                                options={this.get_chartjs_options()}
                            /> :  <Line
                                data={this.get_chartjs_data()}
                                height={500}
                                options={this.get_chartjs_options()}
                            />}

                        </div>
                    </div>
                </div>
            </div>
        )
    }

}